import React, {Component} from 'react'
import {refreshToken} from '../fetch-with-retry'
import View from './view'

class AuthWithPassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      displayForm: false
    }

    refreshToken()
      .then(
        ({token}) => {
          props.recordToken(token)
        }
      )
      .catch(
        () => {
          this.setState({
            displayForm: true
          })
        } 
      )
  }

  render() {
    return this.state.displayForm ?
      <View
        authorisation={this.props.authorisation}
        sendAuthorisation={this.props.sendAuthorisation}
      /> :
      null
  }
}

export default AuthWithPassword


// WEBPACK FOOTER //
// ./src/authorisation/with-password/index.js